import { portalApiGet, portalApiPut } from '@/lib/portal-api';
import type { CoverageDay, CoverageDraft, CoverageRecord, CoverageService } from './doctor-coverage-view';
export const doctorCoverageApi: CoverageService = {
  read: (clinicId, date) => portalApiGet<CoverageDay>(`/coc/doctor-coverage?clinicId=${clinicId}&date=${encodeURIComponent(date)}`),
  save: (operation, draft: CoverageDraft) => portalApiPut<CoverageRecord>(`/coc/doctor-coverage/${encodeURIComponent(operation)}`, draft),
};
